import React, {
  Fragment,
  useEffect,
  forwardRef,
  useContext,
  useState,
} from "react";
import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { Grid, FormControl, DialogActions } from "@mui/material";
import { Button, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ChipList from "../common/ChipList";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import _ from "lodash";
import Loader from "../common/Loader";
import ProjectContext from "../../context/project/ProjectContext";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AddIntelliFiberClientGroup(props: {
  showDialog: boolean;
  selectedClientGroup: any;
  handleClose: Function;
  refresh: Function;
}) {
  const [open, setOpen] = useState(props.showDialog);
  const [clientList, setClientList] = useState<any[]>([]);
  const [selectedClients, setSelectedClients] = useState<string[]>([]);
  const [newClientGroup, setNewClientGroup] = useState<any>({
    GroupName: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState({ type: "", msg: "" });

  let {
    loading,
    clientUserList,
    clientGroup,
    getClients,
    createClientGroup,
    updateClientGroup,
  } = useContext(ProjectContext);

  const handleClose = () => {
    props.handleClose();
    setOpen(false);
  };

  const disableUpdate = () => {
    // console.log("disableUpdate ", props.selectedClientGroup, newClientGroup);
    if (newClientGroup.GroupName !== "" && selectedClients.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const disableAdd = () => {
    // console.log("disableAdd ", newClientGroup, selectedClients);
    if (newClientGroup.GroupName !== "" && selectedClients.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const updateUser = async () => {
    // console.log("updateUser props", newClientGroup);
    if (clientUserList && updateClientGroup) {
      try {
        let getNewClientId = clientUserList
          .filter((ele) => selectedClients.includes(ele.ClientName))
          .map((ele) => ele.ClientID);
        const getOriginaClientId = props.selectedClientGroup.Clients.map(
          (ele) => ele.ClientID
        );
        let addClientIDs = getNewClientId.filter(
          (x) => !getOriginaClientId.includes(x)
        );
        let deleteClientIDs = getOriginaClientId.filter(
          (x) => !getNewClientId.includes(x)
        );

        let payload = {
          GroupName: newClientGroup.GroupName,
          GroupID: props.selectedClientGroup.GroupID,
          addClientIDs: addClientIDs,
          deleteClientIDs: deleteClientIDs,
        };
        const res = await updateClientGroup(payload);
        // console.log("updateUser res", res);
        if (res) {
          setAlertMsg({
            type: "Success",
            msg: "Client Group successfully updated",
          });
          setShowAlert(true);
          setNewClientGroup({
            GroupName: "",
          });
          props.refresh();
        }
      } catch (error) {
        console.log("updateUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const closeAlert = () => {
    if (alertMsg.type === "Success") {
      props.handleClose();
    }
    setAlertMsg({ type: "", msg: "" });
    setShowAlert(false);
  };

  const handleCreateClientGroup = async () => {
    // console.log("createClientGroup props", newClientGroup);
    if (clientGroup && createClientGroup) {
      let isExist = clientGroup.find(
        (ele) => ele.GroupName === newClientGroup.GroupName
      );
      console.log("createClientGroup isExist", isExist);
      if (isExist) {
        setAlertMsg({ type: "Warning", msg: "Client Group already exists" });
        setShowAlert(true);
        return;
      }
      try {
        let getClientId = clientUserList
          ?.filter((ele) => selectedClients.includes(ele.ClientName))
          .map((ele) => ele.ClientID);
        let payload = {
          GroupName: newClientGroup.GroupName,
          Clients: getClientId,
        };
        const res = await createClientGroup(payload);
        // console.log("createClientGroup res", res);
        if (res) {
          setAlertMsg({
            type: "Success",
            msg: "Client Group successfully created",
          });
          setShowAlert(true);
          props.refresh();
        }
      } catch (error) {
        console.log("createClientGroup err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const userRef = React.useRef<HTMLInputElement>(null);

  const addClientToGroup = (event: React.MouseEvent<HTMLElement>) => {
    if (userRef.current) {
      // console.log('addClientToGroup', userRef.current.value);
      if (
        userRef.current.value &&
        !selectedClients.includes(userRef.current.value)
      ) {
        setSelectedClients((clients) => {
          let newClients = [...clients];
          if (userRef.current) newClients.push(userRef.current.value);
          return newClients;
        });
      }
      userRef.current.value = "";
    }
  };

  const handleRemoveClient = (client: string) => {
    setSelectedClients((clients) => clients.filter((ele) => ele !== client));
  };

  const fetchOptionDetails = async () => {
    let clientsDetails: any[] = [];
    if (clientUserList && clientUserList.length > 0) {
      clientsDetails = clientUserList;
    } else if (getClients) {
      const res = await getClients();
      clientsDetails = res;
    }
    let _clientList = clientsDetails.map((ele: any) => ele.ClientName);
    setClientList(_clientList);
  };

  useEffect(() => {
    // if (clientUserList && clientUserList.length > 0) {
      fetchOptionDetails();
    // }
  }, [clientUserList]);

  const handleChange = (e: any) => {
    setNewClientGroup({ ...newClientGroup, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (props.selectedClientGroup) {
      const getSelectedClients = props.selectedClientGroup.Clients.map(
        (ele) => ele.ClientName
      );
      setNewClientGroup(props.selectedClientGroup);
      setSelectedClients(getSelectedClients);
    }
  }, [props.selectedClientGroup]);

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          sx={{
            padding: "0.5rem 2rem",
            fontSize: "1rem",
            background: "#f1f2f6",
            fontWeight: "600",
          }}
        >
          {props.selectedClientGroup ? "Edit Client Group" : "Add Client Group"}
        </DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 0,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ padding: "2rem" }}>
          <Grid
            spacing={2}
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item sx={{ width: "100%" }} xs={12} sm={12}>
              <FormControl required fullWidth sx={{ m: 1 }}>
                <TextField
                  variant="outlined"
                  label="Client Group Name"
                  name="GroupName"
                  value={newClientGroup.GroupName}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>
            <Grid
              md={12}
              sx={{
                margin: 2,
                px: 2,
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Grid
                md={4}
                sx={{
                  px: 2,
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                Clients:
              </Grid>
              <Grid
                md={8}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Autocomplete
                  id="search-auto-complete"
                  fullWidth
                  options={clientList}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search"
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                      }}
                      inputRef={userRef}
                    />
                  )}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ mb: 9 }}
                  onClick={addClientToGroup}
                >
                  <IconButton
                    aria-label="search"
                    component="label"
                    sx={{ backgroundColor: "secondary" }}
                  >
                    <AddIcon />
                  </IconButton>
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className="center-pane" sx={{ mx: 2, px: 2 }}>
            <ChipList
              list={selectedClients}
              deleteHandler={handleRemoveClient}
            />
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "2rem" }}>
          <Button onClick={handleClose}>CANCEL</Button>
          {props.selectedClientGroup ? (
            <Button
              variant="contained"
              onClick={updateUser}
              disabled={disableUpdate()}
            >
              Update
            </Button>
          ) : (
            <Button
              variant="contained"
              disabled={disableAdd()}
              onClick={handleCreateClientGroup}
            >
              Add
            </Button>
          )}
        </DialogActions>

        {loading ? (
          <Grid container justifyContent="center" alignItems="center">
            <Loader />
          </Grid>
        ) : null}
      </Dialog>
      {/* Alert Dialog */}
      <Dialog open={showAlert}>
        <DialogTitle>{alertMsg.type}</DialogTitle>
        <DialogContent>{alertMsg.msg}</DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={closeAlert}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default AddIntelliFiberClientGroup;
